import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-alert-html',
  templateUrl: './alert-html.component.html',
  styleUrl: './alert-html.component.css',
  standalone: false,
})
export class AlertHtmlComponent implements OnInit  {
  
  @Input() errorHtml: string | null = null;
  @Output() close = new EventEmitter<boolean>();
  showError: boolean = false;

  ngOnInit(): void {}


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['errorHtml']) {
      if (this.errorHtml == "" || this.errorHtml == null){
        this.showError = false;
      }
      else{
        this.showError = true;
      }
    }
  }

  hideError(): void {
    this.close.emit();
  }
}
